import React, { memo, useEffect, useState } from 'react'
import styles from './CommonCheckBoxList.module.scss'
import CommonFormFieldWrapper from '../form-field-wrapper/CommonFormFieldWrapper'
import CommonCheckBox from '../checkbox/CommonCheckBox'
import { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
    title?: string
    checkboxTitleProperty: string
    itemsList?: any[]
    required?: boolean,
    value?: string[]
    registerProp?: UseFormRegisterReturn<any>,
    onBottomButtonClick?: (selectedCheckBoxes: any[]) => void
}

const CommonCheckBoxList: React.FC<Props> = memo((props: Props) => {
    const [ searchContent, setSearchContent ] = useState('');
    const [ filterableItemList, setFilterableItemList ] = useState<any[]>()
    const [ selectedCheckBoxes, setSelectedCheckBoxes ] = useState<any[]>([]);
    const [ assigned, setAssigned ] = useState<any[]>([]);


    useEffect(() => {
        setFilterableItemList(props.itemsList)
    }, [props.itemsList])

    
    const onTogglehandler = (item: any) => {

        if (selectedCheckBoxes.find(x => x[props.checkboxTitleProperty] === item[props.checkboxTitleProperty])) {
            setSelectedCheckBoxes(prev => prev.filter(x => x[props.checkboxTitleProperty] !== item[props.checkboxTitleProperty]));
        }
        else {
            setSelectedCheckBoxes(prev => [...prev, item]);
        }
    }

    const changeSearchContent = (e:any) => {
        setSearchContent(e.target.value.trim());
    }

    const onBottomButtonHandler = () => {
        if (props.onBottomButtonClick) {
            props.onBottomButtonClick(selectedCheckBoxes);
            setAssigned(selectedCheckBoxes)
        }
    }
    

    return (
        <div className={styles.checkboxPane}>
            <div className={styles.top}>
                <div className={styles.above}>
                    {props.title}
                    {
                        props.required && <div style={{color: 'red'}}>&nbsp;*</div>
                    }
                </div>
                <CommonFormFieldWrapper borderNotVisible  >
                    <div className={styles.searchBarInside}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.99452 12.5C8.51206 12.5 9.80903 11.9669 10.8854 10.9007C11.9618 9.8345 12.5 8.53609 12.5 7.00548C12.5 5.48794 11.9631 4.19097 10.8893 3.11458C9.81547 2.03819 8.51904 1.5 7 1.5C5.46786 1.5 4.16816 2.0369 3.1009 3.11071C2.03363 4.18453 1.5 5.48096 1.5 7C1.5 8.53214 2.0331 9.83184 3.09929 10.8991C4.1655 11.9664 5.46391 12.5 6.99452 12.5ZM7 14C6.02913 14 5.11974 13.816 4.27185 13.4479C3.42395 13.0799 2.68056 12.5799 2.04167 11.9479C1.40278 11.316 0.902778 10.576 0.541667 9.72802C0.180556 8.88002 0 7.97053 0 6.99956C0 6.04152 0.184028 5.13542 0.552083 4.28125C0.920139 3.42708 1.41864 2.68387 2.04758 2.0516C2.67653 1.41935 3.41569 0.919354 4.26508 0.551604C5.11449 0.183868 6.02548 0 6.99806 0C7.95769 0 8.86458 0.184028 9.71875 0.552083C10.5729 0.920139 11.316 1.42014 11.9479 2.05208C12.5799 2.68403 13.0799 3.42612 13.4479 4.27835C13.816 5.13058 14 6.0381 14 7.00094C14 7.83365 13.8615 8.62125 13.5846 9.36375C13.3078 10.1062 12.9254 10.7836 12.4375 11.3958L16 14.9583L14.9375 16L11.375 12.4583C10.7668 12.9459 10.0939 13.3247 9.35638 13.5948C8.61879 13.8649 7.83333 14 7 14Z" fill="#727278"/>
                        </svg>
                        <input placeholder="Search by name" onChange={changeSearchContent} />
                    </div>
                </CommonFormFieldWrapper>
            </div>
            <div className={styles.middle}>
                {
                    filterableItemList?.map(x => (<CommonCheckBox 
                                                key={x[props.checkboxTitleProperty]} 
                                                title={x[props.checkboxTitleProperty]} 
                                                onToggle={() => onTogglehandler(x)} 
                                                selected={false}
                                                isVisible={searchContent != null ? x[props.checkboxTitleProperty].toLowerCase().includes(searchContent.toLowerCase()) : true}
                                                isAssigned={assigned.find(y => x[props.checkboxTitleProperty] === y[props.checkboxTitleProperty])}/>
                    ))
                }
            </div>
            <div className={styles.bottom}>
                <button className={styles.assignButton} onClick={onBottomButtonHandler}>Assign</button>
            </div>
        </div>
    )
})

export default CommonCheckBoxList
